import React, { Component } from "react";
import { Card, Container, Table } from 'react-bootstrap';

import Alert from './Alert';
import AppContext from '../App.context';
import DataSource from '../../config/api';
import DefaultLoader from './DefaultLoader';
import ConstUtils from "../../config/constants";



export default class CaseDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            loadAlert: false,
            alertVariant: "",
            alertMessage: "",
            caseTestDetails: []
        };
    }

    componentDidMount() {
        const { history } = this.props;
        const hashparam = history.location.search.slice(1);
        DataSource.fetchData(hashparam).then(dparams => {
            if (dparams.success) {
                const { caseDetails } = dparams;
                const message = `
                    Dear <strong>${caseDetails.policyBuyerName}</strong>,<br/><br/>
                    Please find the test instructions for your policy number <strong>${caseDetails.wellnessId}</strong> with ${caseDetails.insuranceCompanyName}
                    <br /><br /> 
                `;

                this.setState({
                    alertMessage: message,
                    loadAlert: true,
                    alertVariant: "primary",
                    isLoading: false,
                    caseTestDetails: [...new Set(caseDetails.testList)]
                });
            } else {
                const errorMsg = dparams.error === "Cannot read property 'RequestJSON' of undefined" ?
                    "An error has occured, please try again." : dparams.error;

                this.setState({
                    alertMessage: errorMsg,
                    loadAlert: true,
                    alertVariant: "warning",
                    isLoading: false,
                });
            }
        }).catch(() => {
            this.setState({
                alertMessage: "Something Went Wrong!!",
                loadAlert: true,
                alertVariant: "warning",
                isLoading: false,
            });
        });
    }

    render() {
        const { isLoading, alertVariant, alertMessage, caseTestDetails } = this.state;

        return (
            isLoading ?
                <DefaultLoader /> :
                <Container>
                    <Alert
                        id={this.state.id}
                        variant={alertVariant}
                        loadAlert
                        text={alertMessage}
                    />

                    <br></br>

                    {
                        caseTestDetails.length > 0 && (
                            <Card>
                                <div className="card-header">
                                    <strong>Test Instructions</strong>
                                </div>
                                <Card.Body>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Test Name</th>
                                                <th>Fasting Required</th>
                                                <th>Instructions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                caseTestDetails.map((test, index) => (
                                                    <tr key={index}>
                                                        <td>{test}</td>
                                                        <td>{ConstUtils.TestDetailsMapping[test] ? ConstUtils.TestDetailsMapping[test]['fastingRequired'] : ''}</td>
                                                        <td style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: ConstUtils.TestDetailsMapping[test] ? ConstUtils.TestDetailsMapping[test]['instructions'] : '' }} />
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        )
                    }
                </Container>
        )
    }
}

CaseDetails.contextType = AppContext;
